'use client';

import { useQuery } from '@tanstack/react-query';
import type { CartFragment } from '../cart-fragment';
import { CART_QUERY_KEY } from '../constants';
import type { ContextCart } from '../types';

async function getCart(): Promise<{
  sanityCart: ContextCart;
  shopifyCart: CartFragment;
} | null> {
  const res = await fetch('/api/cart/get-cart');
  const cart = await res.json();

  if (!cart.data) {
    return null;
  }

  return cart.data;
}

export function useShopifyCart() {
  return useQuery({
    queryKey: [CART_QUERY_KEY],
    queryFn: getCart,
  });
}
